
class CapUpdateScheduleRequestStatus {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'update_schedule_request_status'
}

function create(config) {
  return new CapUpdateScheduleRequestStatus(config)
}

export default {
  key,
  create,
}
